// extracted by mini-css-extract-plugin
export default {"notificationPageContainer":"styles_notificationPageContainer__hHoE9","title":"styles_title__2lMUk","content":"styles_content__ymAMF"};